/* galeria.js
   Obsługuje:
   - miniaturki (pasek przewijany) + duży podgląd
   - lightbox fullscreen z miniaturkami
   - lazy-load video MP4 po kliknięciu przycisku Play
   ---------------------------------------------------------- */
(function () {
    'use strict';

    /* -------------------------------------------------------
       1. DANE – pobieramy ze struktury DOM
    ------------------------------------------------------- */
    var thumbEls      = Array.from(document.querySelectorAll('.gallery__thumb'));
    var mainImg       = document.getElementById('galleryMainImg');
    var mainCounter   = document.getElementById('mainCounter');
    var mainPrev      = document.getElementById('mainPrev');
    var mainNext      = document.getElementById('mainNext');
    var thumbsTrack   = document.getElementById('thumbsTrack');
    var thumbLeft     = document.getElementById('thumbLeft');
    var thumbRight    = document.getElementById('thumbRight');

    var lightbox      = document.getElementById('lightbox');
    var lbImg         = document.getElementById('lightboxImg');
    var lbCounter     = document.getElementById('lightboxCounter');
    var lbClose       = document.getElementById('lightboxClose');
    var lbPrev        = document.getElementById('lightboxPrev');
    var lbNext        = document.getElementById('lightboxNext');
    var lbThumbs      = document.getElementById('lightboxThumbs');

    var galleryMain   = document.getElementById('galleryMain');

    if (!thumbEls.length || !mainImg) return;

    var current = 0;
    var total   = thumbEls.length;

    /* -------------------------------------------------------
       2. MINIATURKI W LIGHTBOXIE – generujemy dynamicznie
    ------------------------------------------------------- */
    thumbEls.forEach(function (th, i) {
        var lbt = document.createElement('div');
        lbt.className = 'gallery__lightbox-thumb' + (i === 0 ? ' is-active' : '');
        lbt.setAttribute('role', 'listitem');
        var img = th.querySelector('img');
        var lbImg2 = document.createElement('img');
        lbImg2.src     = img.src;
        lbImg2.alt     = img.alt;
        lbImg2.loading = 'lazy';
        lbImg2.width   = 54;
        lbImg2.height  = 36;
        lbt.appendChild(lbImg2);
        lbt.addEventListener('click', function () { select(i); });
        lbThumbs.appendChild(lbt);
    });

    /* -------------------------------------------------------
       3. SELECT – zmiana aktywnego zdjęcia
    ------------------------------------------------------- */
    function select(idx) {
        current = idx;
        var th  = thumbEls[idx];
        var src = th.dataset.src;
        var alt = (th.querySelector('img') && th.querySelector('img').alt) || '';

        /* duży podgląd */
        mainImg.src = src;
        mainImg.alt = alt;
        mainCounter.textContent = (idx + 1) + ' / ' + total;

        /* klasy aktywne – miniaturki */
        thumbEls.forEach(function (t, i) {
            t.classList.toggle('is-active', i === idx);
        });

        /* klasy aktywne – lightbox thumbs */
        var lbts = lbThumbs.querySelectorAll('.gallery__lightbox-thumb');
        lbts.forEach(function (t, i) {
            t.classList.toggle('is-active', i === idx);
        });

        /* lightbox img */
        if (lightbox.classList.contains('is-open')) {
            lbImg.src = src;
            lbImg.alt = alt;
            lbCounter.textContent = (idx + 1) + ' / ' + total;
            /* scroll miniaturki lightboxa do widoku */
            if (lbts[idx]) {
                lbts[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }

        /* scroll miniaturki w pasku do widoku */
        if (thumbEls[idx]) {
            thumbEls[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }

    /* -------------------------------------------------------
       4. EVENTY – miniaturki w pasku
    ------------------------------------------------------- */
    thumbEls.forEach(function (th, i) {
        th.addEventListener('click', function () { select(i); });
    });

    /* strzałki paska miniaturek */
    if (thumbLeft)  thumbLeft.addEventListener('click',  function () { thumbsTrack.scrollBy({ left: -220, behavior: 'smooth' }); });
    if (thumbRight) thumbRight.addEventListener('click', function () { thumbsTrack.scrollBy({ left:  220, behavior: 'smooth' }); });

    /* prev/next na dużym podglądzie */
    if (mainPrev) mainPrev.addEventListener('click', function () { select((current - 1 + total) % total); });
    if (mainNext) mainNext.addEventListener('click', function () { select((current + 1) % total); });

    /* -------------------------------------------------------
       5. LIGHTBOX – otwieranie / zamykanie
    ------------------------------------------------------- */
    function openLightbox() {
        var th  = thumbEls[current];
        lbImg.src = th.dataset.src;
        lbImg.alt = (th.querySelector('img') && th.querySelector('img').alt) || '';
        lbCounter.textContent = (current + 1) + ' / ' + total;

        /* sync lbThumbs */
        var lbts = lbThumbs.querySelectorAll('.gallery__lightbox-thumb');
        lbts.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
        if (lbts[current]) lbts[current].scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });

        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        lbClose.focus();
    }

    function closeLightbox() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
        lbImg.src = '';
    }

    /* klik w duży podgląd otwiera lightbox (ale nie na strzałki) */
    if (galleryMain) {
        galleryMain.addEventListener('click', function (e) {
            if (e.target.closest('.gallery__main-nav')) return;
            openLightbox();
        });
    }

    if (lbClose)  lbClose.addEventListener('click', closeLightbox);
    if (lbPrev)   lbPrev.addEventListener('click',  function () { select((current - 1 + total) % total); });
    if (lbNext)   lbNext.addEventListener('click',  function () { select((current + 1) % total); });

    /* zamknij przez klik w tło */
    if (lightbox) {
        lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) closeLightbox();
        });
    }

    /* klawiatura */
    document.addEventListener('keydown', function (e) {
        if (!lightbox || !lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape')      closeLightbox();
        if (e.key === 'ArrowLeft')   select((current - 1 + total) % total);
        if (e.key === 'ArrowRight')  select((current + 1) % total);
    });

    /* -------------------------------------------------------
       6. VIDEO – lazy load MP4
    ------------------------------------------------------- */
    var videoPlayBtn = document.getElementById('videoPlayBtn');
    var videoPoster  = document.getElementById('videoPoster');
    var videoPlayer  = document.getElementById('videoPlayer');

    if (videoPlayBtn && videoPoster && videoPlayer) {
        videoPlayBtn.addEventListener('click', function () {
            /* ukryj poster */
            videoPoster.classList.add('is-hidden');
            /* pokaż i odtwórz video */
            videoPlayer.style.display = 'block';
            videoPlayer.play();
        });
    }

}());